import { render, staticRenderFns } from "./BottomVideoBanner.vue?vue&type=template&id=609b6f46"
import script from "./BottomVideoBanner.vue?vue&type=script&lang=js"
export * from "./BottomVideoBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports